import { createSlice } from "@reduxjs/toolkit";

const resetSlice = createSlice({
  name: "reset",
  initialState: { username: null, type: null },
  reducers: {
    setCurrentUserName: (state, action) => {
      const { username } = action.payload;
      state.username = username;
    },
    unSetCurrentUserName: (state, action) => {
      state.username = null;
    },
  },
});

export const { setCurrentUserName, unSetCurrentUserName } = resetSlice.actions;

export default resetSlice.reducer;

export const selectCurrentUserName = (state) => state.reset.username;
